/**
 * LoadingWipeText
 * Props:
 *  - children: text or node to display
 *  - speed: seconds for one sweep (default 1.4)
 *  - ariaLabel: optional accessible label; if provided it will be announced (role="status")
 *  - className: optional extra classes
 */

/* eslint-disable react/prop-types */
// added the above text for the sonarqube fix

export default function LoadingWipeText({
  children,
  speed = 1.4,
  ariaLabel,
  className = "",
}) {
  const style = { ["--wipe-duration"]: `${speed}s` };
  const liveProps = ariaLabel
    ? { role: "status", "aria-live": "polite", "aria-label": ariaLabel }
    : { "aria-hidden": true };
  return (
    <span className={`loading-wipe ${className}`} style={style} {...liveProps}>
      {children}
    </span>
  );
}
